import axios from 'axios'

// 直接用原生 axios，绕过项目封装
const instance = axios.create({
  baseURL: '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 添加 token
instance.interceptors.request.use(
  config => {
    // 从 cookie 或 localStorage 获取 token
    const token = localStorage.getItem('saber-access-token') ||
      document.cookie.split(';').find(c => c.trim().startsWith('saber-access-token='))
    if (token) {
      const tokenValue = token.includes('=') ? token.split('=')[1] : token
      config.headers['Blade-Auth'] = `bearer ${tokenValue}`
    }
    return config
  },
  error => Promise.reject(error)
)

export const getStatistics = (params) => {
  return instance.post('/api/produce/car-dumper-efficiency/statistics', params)
}

export const getEquipmentOptions = () => {
  return instance.get('/api/produce/car-dumper-efficiency/equipment-options')
}

export const getCoalTypeOptions = () => {
  return instance.get('/api/produce/car-dumper-efficiency/coal-type-options')
}

export const exportReport = (params) => {
  return instance.post('/api/produce/car-dumper-efficiency/export', params)
}
